import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { PromocionesComponent } from './views/promociones/promociones.component';
import { EditarPromocionComponent } from './views/editar-promocion/editar-promocion.component';
import { PromocionBonificadoresComponent } from './views/promocion-bonificadores/promocion-bonificadores.component';
import { PromocionRegalosComponent } from './views/promocion-regalos/promocion-regalos.component';
import { PromocionGruposComponent } from './views/promocion-grupos/promocion-grupos.component';
import { PromocionGrupoClienteComponent } from './views/promocion-grupo-cliente/promocion-grupo-cliente.component';
import { PromocionOficinasComponent } from './views/promocion-oficinas/promocion-oficinas.component';
import { PromocionClientesComponent } from './views/promocion-clientes/promocion-clientes.component';
import { PromocionVendedoresComponent } from './views/promocion-vendedores/promocion-vendedores.component';
import { PromocionSubmarcaComponent } from './views/promocion-submarca/promocion-submarca.component';
import { PromocionCondicionesComponent } from './views/promocion-condiciones/promocion-condiciones.component';

const promocionesRoutes: Routes = [
  {
    path: 'promociones',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'promociones'
      },
      {
        path: 'promociones',
        component: PromocionesComponent
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: EditarPromocionComponent
          },
          {
            path: 'bonificadores',
            component: PromocionBonificadoresComponent
          },
          {
            path: 'regalos',
            component: PromocionRegalosComponent
          },
          {
            path: 'grupos',
            component: PromocionGruposComponent
          },
          {
            path: 'grupo-cliente',
            component: PromocionGrupoClienteComponent
          },
          {
            path: 'oficina-venta',
            component: PromocionOficinasComponent
          },
          {
            path: 'cliente',
            component: PromocionClientesComponent
          },
          {
            path: 'vendedor',
            component: PromocionVendedoresComponent
          },
          {
            path: 'submarca',
            component: PromocionSubmarcaComponent
          },
          {
            path: 'tiers',
            component: PromocionCondicionesComponent
          },
          { path: 'agrupacionTarifa', component: PromocionCondicionesComponent }, // T.20331 Essential: nuevas cond. para promos
          { path: 'canalVendedor', component: PromocionCondicionesComponent },    // T.20331 Essential: nuevas cond. para promos
        ]
      }
    ]
  },
  
];

@NgModule({
  imports: [RouterModule.forChild(promocionesRoutes)],
  exports: [RouterModule]
})
export class PromocionesRoutingModule {
}
